import { render, staticRenderFns } from "./lpfxlist.vue?vue&type=template&id=b9d0ff8a&"
import script from "./lpfxlist.vue?vue&type=script&lang=js&"
export * from "./lpfxlist.vue?vue&type=script&lang=js&"
import style0 from "./lpfxlist.vue?vue&type=style&index=0&id=b9d0ff8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports